export default __webpack_public_path__ + "static/footer-bg-2e1dc6184b3706decaef46447aa0445b.png";